/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useContext } from "react";

// @mui material components
import Card from "@mui/material/Card";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import Tooltip from "@mui/material/Tooltip";
import SuiBox from "components/SuiBox";
import Icon from "@mui/material/Icon";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import IconButton from "@mui/material/IconButton";
import { Descriptions } from "antd";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import { moqOptions } from "utils/data";
import Divider from "@mui/material/Divider";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";
import NumberFormat from "react-number-format";
import moment from "moment";
import { capitalCase } from "capital-case";

import { AccountContext } from "context/account";

const ServiceRequirement = ({ store, updateStore, editable = true }) => {
  const account = useContext(AccountContext);
  const storeMeta = store?.metadata || {};

  let avg_sample_lead_time = storeMeta?.avg_sample_lead_time;
  if (avg_sample_lead_time) {
    avg_sample_lead_time = avg_sample_lead_time + " Day(s)";
  } else {
    avg_sample_lead_time = "-";
  }

  let avg_production_lead_time = storeMeta?.avg_production_lead_time;
  if (avg_production_lead_time) {
    avg_production_lead_time = avg_production_lead_time + " Day(s)";
  } else {
    avg_production_lead_time = "-";
  }

  return (
    <Card sx={{ px: 2, minHeight: "100%" }}>
      <div className="m-4">
        <div className="my-2 flex justify-between">
          <SuiTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            Project Requirements
          </SuiTypography>
        </div>

        <div>
          <SuiBox>
            <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Minimum Order Quantity(MOQ):
            </SuiTypography>
            <div>{storeMeta?.moq || "-"}</div>
          </SuiBox>
          <SuiBox>
            <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Manufacturing Costs Price Range:
            </SuiTypography>
            <div>
              <div className="flex justify-start">
                <NumberFormat
                  value={storeMeta?.costs_price_range_min}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                  renderText={(value, props) => <div {...props}>{value}</div>}
                />
                -{" "}
                <NumberFormat
                  value={storeMeta?.costs_price_range_max}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                  renderText={(value, props) => <div {...props}>{value}</div>}
                />
              </div>
            </div>
          </SuiBox>
          <SuiBox>
            <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Average Sample Production Lead Time:
            </SuiTypography>
            <div>{avg_sample_lead_time || "-"}</div>
          </SuiBox>
          <SuiBox>
            <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Average Production Lead Time:
            </SuiTypography>
            <div>{avg_production_lead_time || "-"}</div>
          </SuiBox>
          <SuiBox>
            <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Type Of Manufacturer: &nbsp;
            </SuiTypography>
            <div> {storeMeta?.company_type || "-"}</div>
          </SuiBox>
          <SuiBox>
            <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Number of Employees: &nbsp;
            </SuiTypography>
            <div>{storeMeta?.employee_amount || "-"}</div>
          </SuiBox>
          <SuiBox>
            <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Year Established: &nbsp;
            </SuiTypography>
            <div>
              {store.establish_date ? moment(store.establish_date, "YYYY").format("YYYY") : "-"}
            </div>
          </SuiBox>
          <SuiBox>
            <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Email: &nbsp;
            </SuiTypography>
            <div>{account?.email ? account?.email : "-"}</div>
          </SuiBox>
          <SuiBox>
            <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Business Phone: &nbsp;
            </SuiTypography>
            <div>{storeMeta?.business_phone ? storeMeta?.business_phone : "-"}</div>
          </SuiBox>
          {storeMeta?.store_tags && storeMeta?.store_tags.length > 0 ? (
            <SuiBox>
              <SuiTypography variant="button" fontWeight="bold" textTransform="capitalize">
                Tags: &nbsp;
              </SuiTypography>
              <div>
                {storeMeta?.store_tags.map((t, index) => (
                  <SuiBadge
                    key={index}
                    variant="contained"
                    className="mr-1 mb-1"
                    textTransform="none"
                    color="dark"
                    badgeContent={capitalCase(t, { stripRegexp: /[^A-Z0-9\'\&\/-_]/gi })}
                    container
                  />
                ))}
              </div>
            </SuiBox>
          ) : null}
        </div>
      </div>
    </Card>
  );
};

export default ServiceRequirement;
